// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-verification-deployment.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-verification-deployment',
  title: 'Verify AI verification, validation and deployment controls',
  description:
    'Confirm that AI systems are verified and validated before deployment and before significant changes (ISO/IEC 42001 Annex A.6.2.4, A.6.2.5), including accuracy, robustness, bias, security and performance testing under realistic conditions. Deployment shall follow a controlled process including go/no-go criteria, rollback plans and approval records. Review the AI verification-and-deployment standard, sample V&V reports, and deployment approvals for AI systems released in the period.',
  category: 'technical',
  scfIds: ['SCF-AIG-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'AI verification-and-deployment standard is published',
    },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
